/*
    Make footer element always stick to the bottom of the page
*/

EventBus.subscribe('run-modules', function () {

    var
        footer = jQuery('footer').last(),
        body = jQuery('body')
    ;

    var setBodyPadding = function () {
        body.css({
            minHeight:      jQuery(window).height(),
            paddingBottom:  footer.outerHeight()
        });
    };

    body.css('position', 'relative');
    jQuery(window).resize(setBodyPadding);
    setBodyPadding();
    
    footer.addClass('sticky-applied').css({
        bottom: 0,
        left: 0,
        position: 'absolute',
        width: '100%'
    });
    
});